// extracted by mini-css-extract-plugin
export default {"wrapper":"Contacts_wrapper__9tanQ","header":"Contacts_header__VS5my","goBack":"Contacts_goBack__MSlS0","container":"Contacts_container__YNsRz"};